import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useMediaQuery, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

// COMPONENTS
import SectionTitleLink from '@/components/SectionTitleLink';
import StageCarousel from '@/components/Carousels/StageSwiperCarousel';
import { SwiperSlide } from '@/components/Carousels/SwiperCarousel';
import AppCardSkeleton from '@/components/Skeletons/AppCardSkeleton';
import ServiceCard from '@/components/Cards/ServiceCard';
import Link from '@/components/Link';

// STYLES
import { Container, CarouselWrapper } from './styles';

const carouselOptions = {
  spaceBetween: 30,
  watchOverflow: true,
  breakpoints: {
    0: {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
    },
    600: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },
    750: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    960: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
  },
};

const ServicesCarousel = props => {
  const {
    data,
    className,
    title,
    link,
    showSeeAll,
    loading,
    analyticsLocation,
    stylesType,
  } = props;
  const [t] = useTranslation();
  const downXs = useMediaQuery(({ breakpoints }) => breakpoints.down('xs'));

  const hasData = !!data.length;

  const skeletons = new Array(downXs ? 2 : 4).fill('');
  const skeletonsSection = skeletons.map((item, index) => {
    return (
      <Grid item xs={6} sm={3} key={index}>
        <AppCardSkeleton type="service" />
      </Grid>
    );
  });

  return (
    <Container className={clsx('carousel-services', `carousel-services--${stylesType}`, className)}>
      {loading ? (
        <Grid container spacing={2}>
          {skeletonsSection}
        </Grid>
      ) : (
        <>
          {hasData ? (
            <>
              {!!title && (
                <SectionTitleLink
                  className="carousel-services__title"
                  title={title}
                  link={link}
                  analyticsLocation={analyticsLocation}
                />
              )}
              <CarouselWrapper>
                <StageCarousel stylesType={stylesType} carouselOptions={carouselOptions}>
                  <>
                    {data.map((serviceData, card_index) => (
                      <SwiperSlide key={card_index}>
                        <ServiceCard data={serviceData} location={`Slot ${card_index + 1}`} />
                      </SwiperSlide>
                    ))}
                    {showSeeAll && !!link && data.length >= 4 && (
                      <SwiperSlide className="card-wrapper--see-all">
                        <div className="dummy-card">
                          <Link
                            className="dummy-card__content"
                            to={link}
                            location={analyticsLocation}
                          >
                            <i className="icon-arrow-right" />
                            <Typography className="p4" component="span">
                              {t('buttons.seeAll')}
                            </Typography>
                          </Link>
                        </div>
                      </SwiperSlide>
                    )}
                  </>
                </StageCarousel>
              </CarouselWrapper>
            </>
          ) : null}
        </>
      )}
    </Container>
  );
};

ServicesCarousel.defaultProps = {
  data: [],
  className: '',
  title: '',
  link: '',
  stylesType: 'collections',
  loading: false,
  showSeeAll: false,
};

ServicesCarousel.propTypes = {
  data: PropTypes.array,
  className: PropTypes.string,
  title: PropTypes.string,
  link: PropTypes.string,
  loading: PropTypes.bool,
  analyticsLocation: PropTypes.string,
  showSeeAll: PropTypes.bool,
  stylesType: PropTypes.string,
};

export default React.memo(ServicesCarousel);
